import React from "react";
import { RenderNumber } from "Utils/renderField/renderReadField";
import { icons } from "icons";
import { fractions, formatFraction } from "utility/variables";

export function formatoNombre(cell, row) {
    return (
        <div>
            <b>{row.producto.nombre}</b>
            <div>{row.nombre}</div>
        </div>
    );
}
export function formatoMarca(cell, row) {
    return (
        <div>
            {row.producto.marca}
        </div>   
    );
}

export function formatoCodigo(cell, row) {
  return (
    <div>
      {row.codigos_barras.map((item, index) => (
        <div key={index}>
          {item.codigo && item.codigo.length > 0 ? item.codigo : "- - -"}
        </div>
      ))}
    </div>
  );
}

export function formatoPeso(cell, row) {
    return (
        <div>
            {row.producto.peso}
        </div>
    );
}

export function formatoKilataje(cell, row) {
    return (
        <div>
            {row.producto.kilataje}
        </div>
    );
}

export function formatoExistencia(cell, row) {
    return <RenderNumber value={row.inventario} decimalScale={2} />;
}

export function formatoExistenciaFracción(cell, row) {
    const formatFraction = (value) => {
        const whole = Math.floor(value);
        const fraction = value - whole;

        if (fraction === 0) return `${whole}`;

        const closestFraction = fractions.reduce((prev, curr) => {
            return Math.abs(curr.value - fraction) < Math.abs(prev.value - fraction)
                ? curr
                : prev;
        });

        return `${whole > 0 ? whole + " " : ""}${closestFraction.fraction}`;
    };

    return (
        <div>
            {row.inventario ? formatFraction(row.inventario) : "0"}
        </div>
    );
}

export function formatoAcciones(props) {
    return (cell, row) => {
        return (
            <div className="w-100 d-flex align-items-center justify-content-end">
                <img className="icon-img" style={{marginRight: "10px"}} onClick={(e) => {
                    e.persist();
                    props.agregar(row);
                    props.cambio_buscador();
                }} src={icons.agregar} alt="Agregar"/>
            </div>
        );
    }
}

export function buscar(props) {
    return () => {
        let search = null; 
        
        return (
            <input
                placeholder={"Buscar (Escanear o Escribir)"}
                type={"text"}
                className="form-control"
                autoFocus={true}
                ref={node => {
                    search = node;
                    if (search && props.search && search.value !== props.search) {
                         if (search.value === "") {
                            search.value = props.search;
                         }
                    }
                }}
                onKeyDown={(e) => { 
                    const isEnter = e.key === 'Enter' || e.keyCode === 13;
                    const isTab = e.key === 'Tab' || e.keyCode === 9;

                    if (isEnter || isTab) { 
                        e.preventDefault();
                        
                        if (search && search.typingTimer) clearTimeout(search.typingTimer);

                        const codigoEscaneado = e.target.value;
                        e.target.value = ""; 
                        if(search) search.value = ""; 

                        setTimeout(() => {
                            if(codigoEscaneado){
                                const codigoLimpio = codigoEscaneado.trim();
                                if (codigoLimpio.length > 0) {
                                    props.agregarPrimer(codigoLimpio);
                                  
                                    props.buscar(""); 
                                    if(search) search.focus();
                                }
                            }
                        }, 20); 
                    }
                }}
                onChange={(e) => {
                    const textoActual = e.target.value;
                    
                    
                    if (search) {
                        if (search.typingTimer) clearTimeout(search.typingTimer);

                        search.typingTimer = setTimeout(() => {
                           props.buscar(textoActual); 
                        }, 500); 
                    }
                }}
                onFocus={(e) => e.target.select()}
            />
        );
    }
}

export function formatoProducto(cell, row) {
    return (
        <div>
            <b>{row.producto.nombre}</b>
            <div><small>{row.nombre}</small></div>
        </div>
    );
}

export function formatoAvatar(cell, row) {
    if (row.producto.img_cropped !== ""){
      return <img className="imagen-sm" src={row.producto.img_cropped} alt="" style={{width:"45px", height:"45px"}}/>
    }
    else{
      return <img className="imagen-sm" src={icons.img_default} alt="" style={{width:"40px", height:"40px"}}/>
    }
}

export function formatoAvatarMovil(cell, row) {
    if (row.producto.img_cropped !== ""){
      return <img className="imagen-sm" src={row.producto.img_cropped} alt="" style={{width:"70px", height:"70px", border:"2px solid black"}}/>
    }
    else{
      return <img className="imagen-sm" src={icons.img_default} alt="" style={{width:"70px", height:"70px"}}/>
    }
}

export function formatoInventario(cell, producto) {
    return (
        <div>
            <RenderNumber value={producto.inventario} />
        </div>
    );
}

export function formatoInventarioFraccion(cell, producto) {
    return (
        <div>
            {producto.inventario ? formatFraction(producto.inventario) : "0"}
        </div>
    );
}
